import Map from "@/pages/map.vue";
import { Route } from "@soft-db/typed-router";

const mapRoutes = new Route({
	path: "map",
	component: Map,
});

export default mapRoutes;
